import { CancelToken } from 'apisauce';
import React from 'react';
import { useState } from 'react';
import appapi from '../../../api/apiClient';
import { useDispatch, useSelector } from 'react-redux';
import { showmessage } from '../../../utils/toastr';
import { setLoading } from '../../../redux/features/appSlice';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import NotificationCard from './Components/NotificationCard';
import { CircularProgress, Stack, Typography } from '@mui/material';
import NoDataFound from '../../../components/NoDataFound/NoDataFound';
import { initNotifyCount } from '../../../redux/features/layoutSlice';

export default function Notification({ handleNotifyMenuClose, getNotifyCount }) {
  const dispatch = useDispatch();
  const navigation = useNavigate();

  let source2 = CancelToken.source();

  const { userId, user, companyDetails } = useSelector((state) => state.auth);

  const [notificationList, setNotificationList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  const [payload, setPayload] = useState({
    page: 1,
    limit: 20,
  });

  const handleOpenNotification = async (info) => {
    const response = await appapi.put(`notification/${info?._id}`);
    if (response.ok) {
      dispatch(setLoading(false));
      const data = response.data;
      if (data.status === '7400') {
        handleNotifyMenuClose();
       dispatch(initNotifyCount())
        if (info?.subType === 'trade') navigation('tradeManagement', { state: { notificationData: info?.data } });
      } else {
        setHasMore(false);
        showmessage(data.message, 'error');
      }
    } else {
      dispatch(setLoading(false));
      // showmessage(Something went wrong!, 'error', 2000);
    }
  };

  const getNotification = async () => {
    setLoading(true);
    source2.cancel();
    source2 = CancelToken.source();
    const response = await appapi.get(
      `notification/${userId}`,
      {
        pageNumber: payload.page,
        pageSize: payload.limit,
      },
      {
        cancelToken: source2.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        let notificationData = data?.response;
        setNotificationList([...notificationList, ...notificationData]);
        setPayload((prev) => ({ ...prev, totalLength: notificationData?.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
        if (data?.response?.length <= 0) {
          setHasMore(false);
        }
      } else {
        setNotificationList([]);
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setIsLoading(false);
        setHasMore(false);
      }
    } else {
      setNotificationList([]);
      setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    getNotification();
    return () => {
      if (source2) {
        source2.cancel();
      }
    };
  }, [payload.page]);

  const fetchData = async () => {
    setPayload((prevState) => ({ ...prevState, page: prevState.page + 1 }));
  };

  return (
    <InfiniteScroll
      dataLength={notificationList.length}
      next={fetchData}
      hasMore={hasMore}
      height={'calc(100vh - 204px)'}
      loader={
        isLoading && (
          <Stack alignItems={'center'}>
            <CircularProgress />
          </Stack>
        )
      }
    >
      {notificationList && notificationList.length > 0
        ? notificationList.map((item, index) => (
            <NotificationCard
              data={item}
              onClick={(info) => {
                handleOpenNotification(info);
              }}
            />
          ))
        : !isLoading && (
            <Stack
              flex={1}
              alignItems="center"
              justifyContent={'center'}
              style={{ marginTop: '200px' }}
            >
              <Typography
                className="ff-Roboto fw-regular fs-16"
                style={{ color: '#707070' }}
              >
                We couldn't find any data for your request
              </Typography>
            </Stack>
          )}
    </InfiniteScroll>
  );
}
